import { Pipe, PipeTransform } from '@angular/core';
import { Activity } from '../models/activity/activity';
import { ScheduleInfoBasicDto } from '../models/calendar/schedule/schedule-info-basic';
import { StaffBasicDto } from '../models/staff/staff-basic-dto';

@Pipe({
    name: 'filterActivities',
    pure: false
})
export class FilterActivities implements PipeTransform {

    transform(items: ScheduleInfoBasicDto[], filterObject: {selectedActivities: Activity[],
      selectedStaff: StaffBasicDto[]}): ScheduleInfoBasicDto[] {
      let filteredItems = items;
      if(!filterObject.selectedActivities?.length && !filterObject.selectedStaff?.length ) {
        return filteredItems;
      }
      if(filterObject.selectedActivities?.length) {
        filteredItems = filteredItems.filter(schedule => filterObject.selectedActivities.find(activity => activity.id === schedule.activity?.id));
      }
      if(filterObject.selectedStaff?.length) {
        filteredItems = filteredItems.filter(schedule => filterObject.selectedStaff.find(staff => staff.idStaff === schedule.staff?.idStaff));

      }
      return filteredItems;
    }
}
